import React, { useEffect, useState, useRef } from 'react'
import {useTheme}                             from "@mui/material"

const CountdownTimer = ({ minutes = 0, seconds = 0, onComplete, color }) => {
	const theme = useTheme()
	const [timeLeft, setTimeLeft] = useState(minutes * 60 + seconds)
	const endTimeRef = useRef(null)

	useEffect(() => {
		endTimeRef.current = Date.now() + timeLeft * 1000

		const tick = () => {
			const remaining = Math.max(0, Math.round((endTimeRef.current - Date.now()) / 1000))
			setTimeLeft(remaining)

			if (remaining === 0) {
				clearInterval(interval)
				onComplete && onComplete()
			}
		}

		const interval = setInterval(tick, 250)
		return () => clearInterval(interval)
	}, [])

	const format = (val) => String(val).padStart(2, '0')

	const mm = Math.floor(timeLeft / 60)
	const ss = format(timeLeft % 60)

	return (
		<span style={{
				display: "inline-block",
				fontFamily: "monospace",
				paddingLeft: "10px",
				paddingRight: "10px",
				color: color || theme.palette.error.main
			}}
		>
			{mm}m {ss}s
		</span>
	)
}

export default CountdownTimer
